import React from "react";
import { Question, Sparkle, ChartLineUp } from "@phosphor-icons/react";

export const QuizCTA = ({ onOpen }) => {
  return (
    <section data-testid="quiz-cta-section" className="py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative glass-strong rounded-3xl p-8 sm:p-12 overflow-hidden">
          <div className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-brand/20 blur-[120px]" />
          <div className="absolute -bottom-24 -right-24 w-[320px] h-[320px] rounded-full bg-brand-cyan/15 blur-[120px]" />

          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-cyan/10 border border-brand-cyan/30 mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-5">
                <Sparkle size={12} weight="fill" /> 5 вопросов · 60 секунд
              </div>
              <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
                Узнайте потенциал
                <br />
                <span className="text-brand-cyan">внедрения за минуту.</span>
              </h2>
              <p className="mt-5 text-muted text-base leading-relaxed max-w-xl">
                Ответьте на 5 коротких вопросов о вашей инфраструктуре — получите
                индивидуальный отчёт с оценкой готовности и сценарием пилота.
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                <button
                  onClick={onOpen}
                  data-testid="quiz-cta-btn"
                  className="btn-primary rounded-lg px-6 py-3 font-semibold inline-flex items-center gap-2"
                >
                  <Question size={18} weight="bold" /> Пройти квиз
                </button>
                <a
                  href="#roi"
                  className="btn-secondary rounded-lg px-6 py-3 font-semibold inline-flex items-center gap-2"
                >
                  <ChartLineUp size={18} weight="bold" /> Калькулятор ROI
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl bg-ink-elevated/95 border border-ink-text/10 p-6">
                <div className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-4">
                  Что вы получите
                </div>
                <ul className="space-y-3 text-sm">
                  {[
                    "Оценка готовности кластера к оркестрации",
                    "Прогноз экономии в долларах за год",
                    "Сценарий пилота на 30 дней",
                    "Сравнение с лучшими практиками индустрии",
                  ].map((t, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-brand-cyan shadow-[0_0_8px_#0099C9]" />
                      <span className="text-muted">{t}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuizCTA;
